export const shortenTo = (value: string, length: number) => {
  let text = value
  if(text !== null && text.length > length) {
    text = text.slice(0, length-4)
    const end = text.lastIndexOf(' ')
    text = text.slice(0, end);
    text += ' ...'
  }
  return text
}



// WEBPACK FOOTER //
// ./src/utils/stringManipulation.tsx